import { Appeal } from "../../classes";
// import moment from "moment";
const AppealModule = {
  namespaced: true,
  state: {
    appeals: [],
    appeal: {},
    isFirstWaitingStatus: true,
    waitingStatus: null
  },
  actions: {
    getAppeals: async ({ commit, rootGetters }, payload) => {
      let marketId = payload.marketId ? payload.marketId : rootGetters["markets/getMarketId"]
      try {
        commit("setIsFirstWaitingStatus");
        const data = await Appeal.getAppealsByMarket({ marketId });
        commit("setAppeals", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getAppealBetweenDateByMarket: async ({ commit }, formData) => {
      try {
        commit("setAppeals", [])
        const data = await Appeal.getAppealBetweenDateByMarket(formData)
        commit("setAppeals", data)
        return data
      } catch (error) {
        throw error
      }
    },
    createAppeal: async ({ dispatch, commit, rootGetters }, payload) => {
      try {
        const newObj = { ...payload, };
        const data = await Appeal.createAppeal(newObj);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getAppeal: async ({ commit }, payload) => {
      try {
        const data = await Appeal.getAppeal({ id: payload.id });
        commit("setAppeal", { appeal: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    updateAppeal: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const newObj = {
          ...payload,
        };
        const data = await Appeal.updateAppeal(newObj);
        commit("setAppeal", { appeal: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    changeStatusAppeal: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const newObj = {
          ...payload,
        };
        const data = await Appeal.changeStatusAppeal(newObj);
        commit("setAppeal", { appeal: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    checkWaitingStatus: async ({ commit }, marketId) => {
      try {
        const data = await Appeal.checkWaitingStatus({ id: marketId });
        commit("setWaitingStatus", { waitingStatus: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    getAppeals: state => state.appeals,
    getWaitingStatusByMarketId: (state) => {
      const appeals = state.appeals || []
      let temp
      if (!state.isFirstWaitingStatus) {
        temp = appeals.find(appeal => appeal.status === 'waiting')
      } else {
        temp = state.waitingStatus
      }
      return temp
    },
  },
  mutations: {
    setAppeal: (state, payload) => {
      state.appeal = payload.appeal;
    },
    setWaitingStatus: (state, payload) => {
      state.waitingStatus = payload.waitingStatus;
    },
    setIsFirstWaitingStatus: (state) => {
      state.isFirstWaitingStatus = false;
    },
    setAppeals: (state, payload) => {
      state.appeals = payload;
    },
  }
};
export default AppealModule;
